var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('PageTitle',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_c('PageContent',[_c('Container',[_c('div',{ref:"content",staticClass:"page-static",domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }